import { useToaster } from '@amzn/dots-core-ui';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { LMSLabMutation, useClient, useGet, useUpdate } from '$/api';
import { CorePage, CorePageTitle } from '$/components';
import { useIdParam } from '$/hooks';
import { LabForm } from './components';
import { LabDetailUri, LabsUri, RootUri } from '$/features/routes';

export const LabEditPage = (): JSX.Element => {
  const id = useIdParam();
  const history = useHistory();
  const { openToast } = useToaster();
  const { lmslabs } = useClient();
  const {
    data: lab,
    error,
    isError,
    isLoading,
  } = useGet(lmslabs.resourceKey, lmslabs.get, id);
  const { mutateAsync } = useUpdate(lmslabs.resourceKey, lmslabs.update, false);
  const onSubmit = useCallback(
    async (item: Partial<LMSLabMutation>): Promise<void> => {
      await mutateAsync({ id, item });
      openToast({
        title: 'Success!',
        message: `${lab?.name} has been updated.`,
        type: 'success',
      });
      history.push(LabDetailUri(id));
    },
    [mutateAsync, id, openToast, lab, history]
  );
  return (
    <CorePage
      title="Edit"
      isLoading={isLoading}
      isError={isError}
      error={error}
      breadcrumbs={[
        { title: 'LMS Lab Dashboard', href: RootUri },
        { title: 'Labs', href: LabsUri },
        { title: lab?.name ?? '', href: LabDetailUri(id) },
      ]}
      header={<CorePageTitle title={lab ? `Edit ${lab?.name}` : ''} />}
    >
      <LabForm
        onCancel={() => history.push(LabDetailUri(id))}
        onSubmit={onSubmit}
        lab={lab}
      />
      {/*
      <Labgit satAddHostForm
        onCancel={() => history.push(LabDetailUri(id))}
        onSubmit={onSubmit}
        lab={lab}
      />
      */}
    </CorePage>
  );
};
